'use client'
import { Article as CArticle } from '@/components/Article'
import { Button } from '@/components/Button'
import { Picture } from '@/components/Picture'
import { Icon } from '@/icons'
import { Article } from '@/services/Api/generated'
import { Thumbnail } from '@/store/Thumbnail'
import cn from 'classnames'
import { FC, useCallback, useRef, useState } from 'react'
import { FreeMode } from 'swiper/modules'
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react'
import styles from './Articles.module.scss'

interface ArticlesProps {
  className?: string
  articles: Article[]
}
export const Articles: FC<ArticlesProps> = ({ className, articles }) => {
  const swiperRef = useRef<SwiperRef>(null)

  const [isBeginning, setIsBeginning] = useState(true)
  const [isEnd, setIsEnd] = useState(false)

  const updateButtonsState = useCallback(() => {
    if (swiperRef.current) {
      const swiper = swiperRef.current.swiper
      setIsBeginning(swiper.isBeginning)
      setIsEnd(swiper.isEnd)
    }
  }, [])

  const next = useCallback(() => {
    swiperRef.current?.swiper.slideNext()
  }, [])

  const prev = useCallback(() => {
    swiperRef.current?.swiper.slidePrev()
  }, [])

  return (
    <div className={styles.container}>
      <Swiper
        className={cn(styles.recomended, className)}
        wrapperClass={styles.swiperWrapper}
        ref={swiperRef}
        spaceBetween={24}
        slidesPerView={'auto'}
        modules={[FreeMode]}
        freeMode={true}
        breakpoints={{
          320: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        }}
        onSlideChange={updateButtonsState}
        onSwiper={updateButtonsState}
        onResize={updateButtonsState}
      >
        {articles.map((article) => (
          <SwiperSlide key={article.slug} className={styles.slide}>
            <CArticle
              className={styles.article}
              id={article.slug}
              image={
                <>
                  {article.thumbnail != null ? (
                    <Picture
                      thumbnail={new Thumbnail(article.thumbnail)}
                      className={styles.largeArticleImage}
                      alt=""
                    />
                  ) : null}
                </>
              }
              title={article.title}
              category={article.category}
              publishedAt={article.publishedAt}
              readTime={article.readingTime}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <Button
        variant="opacity"
        className={cn(styles.button, styles.prev, {
          [styles.hideOnMd]: articles.length <= 3,
          [styles.hideOnSm]: articles.length <= 2,
          [styles.hideOnXs]: articles.length <= 1,
        })}
        onClick={prev}
        disabled={isBeginning}
        ariaLabel="Назад"
      >
        <Icon name="arrow" className={styles.iconPrev} />
      </Button>
      <Button
        variant="opacity"
        className={cn(styles.button, styles.next, {
          [styles.hideOnMd]: articles.length <= 3,
          [styles.hideOnSm]: articles.length <= 2,
          [styles.hideOnXs]: articles.length <= 1,
        })}
        onClick={next}
        disabled={isEnd}
        ariaLabel="Вперед"
      >
        <Icon name="arrow" className={styles.iconNext} />
      </Button>
    </div>
  )
}
